"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = exports.spacing = exports.shadow = exports.imageIconSizes = exports.iconSizes = exports.iconSize = exports.height = exports.fonts = exports.font = exports.colors = exports.button = exports.borderRadius = exports.avatarSize = void 0;
// Global style variables

var color = {
  red: {
    50: '#FFEBEB',
    100: '#FEB6B3',
    200: '#FD8B86',
    300: '#FD5A53',
    400: '#FB3128',
    500: '#EB0A00',
    600: '#DB0900',
    700: '#C20800',
    800: '#AD0700',
    900: '#8F0600'
  },
  pink: {
    50: '#FFE5F4',
    100: '#FFBDE4',
    200: '#FF8FD0',
    300: '#FF61BD',
    400: '#FF3DAE',
    500: '#FF0094',
    600: '#E50085',
    700: '#C70074',
    800: '#A80061',
    900: '#8A0050'
  },
  purple: {
    50: '#F6E7F8',
    100: '#E2ACEC',
    200: '#D279E1',
    300: '#BD53D0',
    400: '#AB33C2',
    500: '#9B27B0',
    600: '#852197',
    700: '#6F1C7E',
    800: '#591665',
    900: '#43114C'
  },
  brand: {
    50: '#F0E7FE',
    100: '#CEAEFA',
    200: '#B27DF7',
    300: '#9C52FF',
    400: '#8327FC',
    500: '#6E0FEB',
    600: '#5A0AC5',
    700: '#4A0A9E',
    800: '#41098B',
    900: '#360873'
  },
  blue: {
    50: '#E5F4FF',
    100: '#ADDBFF',
    200: '#75C2FF',
    300: '#4DB0FF',
    400: '#1F9CFF',
    500: '#008BFA',
    600: '#007ADB',
    700: '#0768C0',
    800: '#00589E',
    900: '#004A85'
  },
  pine: {
    50: '#E2F3F1',
    100: '#AADFD9',
    200: '#6CCBC1',
    300: '#3BB0A4',
    400: '#00998A',
    500: '#118579',
    600: '#00756A',
    700: '#00665C',
    800: '#005950',
    900: '#004D46'
  },
  green: {
    50: '#E2F8E4',
    100: '#90E498',
    200: '#6BD675',
    300: '#59C063',
    400: '#49B153',
    500: '#42A04B',
    600: '#3C9044',
    700: '#347E3C',
    800: '#2D6C33',
    900: '#255A2A'
  },
  yellow: {
    50: '#FEFCE6',
    100: '#FFF9C2',
    200: '#FFF59E',
    300: '#FFF37A',
    400: '#FFEE47',
    500: '#FFE700',
    600: '#FAD900',
    700: '#E2C403',
    800: '#D7B404',
    900: '#C69F10'
  },
  orange: {
    50: '#FFF8E5',
    100: '#FFEAB3',
    200: '#FFDE85',
    300: '#FFD35C',
    400: '#FFC833',
    500: '#FFB915',
    600: '#FFAD0A',
    700: '#FF9D00',
    800: '#FA8900',
    900: '#E57700'
  },
  dark: {
    50: '#9696A6',
    100: '#8E8F9F',
    200: '#868798',
    300: '#7C7D8D',
    400: '#6D6E7E',
    500: '#5C5D6B',
    600: '#484856',
    700: '#393946',
    800: '#2C2C3A',
    900: '#202028'
  },
  light: {
    50: '#FFFFFF',
    100: '#F7F7FE',
    200: '#F1F1FD',
    300: '#E7E7F3',
    400: '#DDDDE9',
    500: '#D3D3DF',
    600: '#C9C9D4',
    700: '#BBBBC8',
    800: '#AEAEBC',
    900: '#A0A0B0'
  }
};
var borderRadius = exports.borderRadius = {
  s: '4px',
  m: '8px',
  l: '12px',
  xl: '18px'
};
var spacing = exports.spacing = {
  xxs: '4px',
  xs: '8px',
  s: '12px',
  m: '16px',
  l: '24px',
  xl: '32px',
  xxl: '48px'
};
var shadow = exports.shadow = {
  s: 'box-shadow: 0px 1px 4px rgba(0,0,0,0.12);',
  m: 'box-shadow: 0px 2px 8px rgba(0,0,0,0.12);',
  l: 'box-shadow: 0px 4px 16px rgba(0,0,0,0.12);',
  xl: 'box-shadow: 0px 8px 24px rgba(0,0,0,0.12);'
};
var font = exports.font = {
  heading: {
    xl: 'font-family: Poppins, sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  letter-spacing: 0;\n  line-height: 24px;',
    l: 'font-family: Inter, sans-serif;\n  font-weight: bold;\n  font-size: 18px;\n  letter-spacing: 0.2px;\n  line-height: 20px;',
    m: 'font-family: Inter, sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  letter-spacing: 0.2px;\n  line-height: 20px;',
    s: 'font-family: Inter, sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  line-height: 16px;'
  },
  base: {
    regular: 'font-family: Inter, sans-serif;\n  font-weight: normal;\n  font-size: 13px;\n  letter-spacing: 0px;\n  line-height: 16px;',
    bold: 'font-family: Inter, sans-serif;\n  font-weight: 600;\n  font-size: 13px;\n  letter-spacing: 0px;\n  line-height: 16px;',
    paragraph: 'font-family: Inter, sans-serif;\n  font-weight: normal;\n  font-size: 13px;\n  letter-spacing: 0px;\n  line-height: 20px;'
  },
  small: {
    regular: 'font-family: Inter, sans-serif;\n  font-weight: normal;\n  font-size: 11px;\n  letter-spacing: 0px;\n  line-height: 12px;',
    bold: 'font-family: Inter, sans-serif;\n  font-weight: 600;\n  font-size: 11px;\n  letter-spacing: 0px;\n  line-height: 12px;',
    paragraph: 'font-family: Inter, sans-serif;\n  font-weight: normal;\n  font-size: 11px;\n  letter-spacing: 0px;\n  line-height: 16px;'
  },
  label: {
    regular: 'font-family: Inter, sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  letter-spacing: 0px;\n  line-height: 20px;',
    s: 'font-family: Inter, sans-serif;\n  font-weight: 500;\n  font-size: 10px;\n  letter-spacing: 0px;\n  line-height: 12px;'
  },
  utility: {
    caption: 'font-family: Inter, sans-serif;\n  font-weight: 500;\n  font-size: 9px;\n  letter-spacing: 1px;\n  line-height: 12px;',
    overline: 'font-family: Inter, sans-serif;\n  font-weight: normal;\n  font-size: 11px;\n  letter-spacing: 0px;\n  line-height: 12px;'
  }
};
var button = exports.button = {
  type: {
    pink: {
      textColor: color.light['50']
    },
    secondary: {
      textColor: color.dark['700']
    },
    ghost: {
      textColor: color.dark['700']
    },
    destructive: {
      textColor: color.light['50']
    },
    creative: {
      textColor: color.light['50']
    }
  }
};
var iconSize = exports.iconSize = {
  s: '16',
  m: '20',
  l: '24'
};
var avatarSize = exports.avatarSize = {
  s: '16px',
  m: '20px',
  l: '32px',
  xl: '64px'
};
var colors = exports.colors = {
  creative: color.green['400'],
  destructive: color.red['500'],
  warning: color.orange['700'],
  icon: {
    primary: color.dark['700'],
    secondary: color.dark['100'],
    disabled: color.dark['100'],
    error: color.red['500'],
    brand: color.brand['500'],
    favorite: color.orange['400']
  },
  text: {
    primary: color.dark['700'],
    secondary: color.dark['100'],
    error: color.red['500'],
    destructive: color.red['500'],
    warning: color.orange['700'],
    creative: color.green['400'],
    disabled: color.light['500'],
    light: color.light['50'],
    brand: color.brand['500']
  },
  entity: {
    lightRed: color.red['100'],
    red: color.red['200'],
    pink: color.pink['200'],
    purple: color.purple['200'],
    brand: color.brand['200'],
    blue: color.blue['200'],
    pine: color.pine['200'],
    green: color.green['200'],
    yellow: color.yellow['200'],
    orange: color.orange['200'],
    dark: color.dark['200'],
    light: color.light['200']
  },
  link: {
    active: color.blue['700'],
    visited: color.brand['500']
  },
  background: {
    primary: color.light['50'],
    layover: color.dark['900'],
    brand: color.brand['500'],
    pink: {
      default: color.pink['500'],
      hover: color.pink['600'],
      active: color.pink['700'],
      disabled: color.pink['50']
    },
    secondary: {
      default: color.light['100'],
      hover: color.light['300'],
      active: color.light['400'],
      disabled: color.light['100']
    },
    tertiary: {
      default: color.light['300']
    },
    ghost: {
      default: 'transparent',
      hover: color.light['300'],
      active: color.light['300'],
      disabled: color.light['50']
    },
    destructive: {
      default: color.red['500'],
      hover: color.red['600'],
      active: color.red['700'],
      disabled: color.red['50']
    },
    creative: {
      default: color.green['400'],
      hover: color.green['500'],
      active: color.green['600'],
      disabled: color.green['50']
    },
    error: color.red['50'],
    disabled: color.light['100'],
    noticeBanner: {
      warning: color.light['50'],
      alert: color.light['100'],
      notice: color.light['50']
    }
  },
  outline: {
    focus: color.blue['50'],
    active: color.blue['50']
  },
  border: {
    secondary: color.light['500'],
    focus: color.blue['300'],
    active: color.blue['300'],
    primary: {
      default: color.light['300'],
      hover: color.light['700']
    },
    noticeBanner: {
      warning: color.red['100'],
      alert: color.light['300'],
      notice: color.light['300']
    },
    ghost: {
      default: color.light['50'],
      hover: color.light['300']
    },
    error: {
      default: color.red['100'],
      hover: color.red['300']
    },
    disabled: color.light['300']
  }
};
var fonts = exports.fonts = {
  atom: {
    s: font.small.regular,
    m: font.base.regular,
    l: font.base.regular
  },
  button: {
    s: font.label.s,
    m: font.label.regular,
    l: font.label.regular
  }
};
var height = exports.height = {
  s: '28px',
  m: '32px',
  l: '40px'
};
var iconSizes = exports.iconSizes = {
  atom: {
    s: 's',
    m: 'm',
    l: 'm'
  }
};
var imageIconSizes = exports.imageIconSizes = {
  atom: {
    s: 's',
    m: 'm',
    l: 'm'
  }
};
var theme = exports.theme = {
  colors: colors,
  font: font,
  borderRadius: borderRadius,
  spacing: spacing,
  shadow: shadow
};